module.exports = __webpack_public_path__ + "images/mobile/home_enterprise_icons-0c9fd8e22409a654af0f05de8b16ffd0.png";